import MessageBubble from './MessageBubble';
import { incidentAnalystApi } from '../../../services/api';
import type { AgentSpec } from '../../agents/shared/types';

/**
 * Incident Analyst, migrated onto the shared AgentConversation /
 * AgentLanding. Behaviour byte-identical to the old self-contained
 * page — its rich MessageBubble + DetailCards are reused AS-IS via
 * this spec. Copy/constants preserved verbatim.
 */
export const incidentAnalystSpec: AgentSpec = {
  title: 'Incident Analyst',
  subtitle:
    'Root-cause investigation for open incidents. Walks upstream and '
    + 'downstream lineage, cites observability evidence, and delivers '
    + 'grounded narratives.',
  heroHeading: 'Investigate open incidents in chat',
  heroDescription:
    'The Incident Analyst walks upstream and downstream lineage, cites '
    + 'observability evidence, and delivers grounded root-cause '
    + 'narratives — with links to incident and mapping-run pages.',
  placeholder: 'Ask the analyst — list incidents, check table health, explain incident X...',

  backRoute: '/observability/analyst',
  sessionRouteBase: '/observability/analyst/sessions',
  queryKeyPrefix: 'incident-analyst',
  streamUrlBase: '/api/incident-analyst',

  api: incidentAnalystApi,

  MessageBubble,
  detailCardTools: ['profile_tables', 'generate_dictionary', 'suggest_rules', 'suggest_mapping'],

  samplePrompts: [
    { label: 'List open incidents on dim_party_analytics', prompt: 'List open incidents on dim_party_analytics',
      help: 'dim_party_analytics = the monitored table name (use yours). Returns that table’s currently-open data incidents.' },
    { label: 'Explain incident 33', prompt: 'Explain incident 33',
      help: '33 = an incident id (from the incidents list — use the id you care about). Returns its root cause: what broke, in which column/check, and why.' },
    { label: 'Show the current health of DEMO_TGT.DIM_PARTY', prompt: 'Show the current health of DEMO_TGT.DIM_PARTY',
      help: 'DEMO_TGT.DIM_PARTY is SCHEMA.TABLE (DEMO_TGT = schema, DIM_PARTY = table — use yours). Shows that table’s live health: freshness, row volume, schema, and recent check results.' },
    { label: 'What is the SDQ score for dim_party_analytics?', prompt: 'What is the SDQ score for dim_party_analytics?',
      help: 'dim_party_analytics = the table name (use yours). Returns that table’s structured data-quality (SDQ) score with the per-dimension breakdown and lineage.' },
  ],
};
